"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropsFromFields = void 0;
const getPropsFromFields = (fields, propName) => {
    return fields
        .filter(field => field === null || field === void 0 ? void 0 : field[propName])
        .reduce((acc, item) => (Object.assign(Object.assign({}, acc), item[propName])), {});
};
exports.getPropsFromFields = getPropsFromFields;
